import { Link, useLocation } from "react-router-dom";
import { xContext } from "../context/userContext";
import React, { useContext, useState, useEffect } from "react";

const Header = () => {
  const ctx = useContext(xContext);
  const location = useLocation();
  const active = location.pathname;
  const [isScrolled, setIsScrolled] = useState(false);

  const reload = () => {
    window.location.reload();
  };

  const handleScroll = () => {
    if (window.scrollY > 10) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`main-header main-header__two ${
        isScrolled ? "fixed-header" : ""
      }`}
    >
      <nav className="main-menu main-menu__two">
        <div className="container">
          <div className="logo-box">
            <div onClick={() => reload()} aria-label="logo image">
              <Link to={"/"}>
                {" "}
                <img
                  src="assets/images/centurynew.png"
                  width={155}
                  alt=""
                />{" "}
              </Link>
            </div>
            <span className="fa fa-bars mobile-nav__toggler" />
          </div>
          <div className="logo-box">
            <div onClick={() => reload()} aria-label="logo image">
              <Link to={"/"}>
                {" "}
                <img
                  src="assets/images/playstore.png"
                  width={135}
                  style={{ marginTop: 20, marginLeft: 5 }}
                  alt=""
                />{" "}
              </Link>
            </div>
            <span className="fa fa-bars mobile-nav__toggler" />
          </div>
          <ul className="main-menu__list">
            <li onClick={() => reload()} className="dropdown current">
              <Link to={"/"}> Home</Link>
              <ul></ul>
            </li>
            <li className="dropdown">
              <a href="/#about">About Us</a>
            </li>
            <li className="dropdown">
              <a href="/#services">Services</a>
            </li>

            <li className="dropdown">
              <Link to={"/contacts"}>Contact Us</Link>
            </li>
            <li className="search-btn search-toggler">
              <a href="#">
                {/* <i className="pylon-icon-magnifying-glass" /> */}
              </a>
            </li>
          </ul>

          <div className="main-header__info">
            <div className="main-header__info-phone">
              <i className="pylon-icon-telephone" />
              <div className="main-header__info-phone-content">
                <span>Call Anytime</span>
                <h3>
                  <a href="#">+260772314242 / +260760665151</a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
